namespace TabAurous.OMS {
    export interface FinancialYearForm {
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        FinancialYearCode: Serenity.StringEditor;
    }

    export class FinancialYearForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.FinancialYear';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FinancialYearForm.init)  {
                FinancialYearForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;

                Q.initFormType(FinancialYearForm, [
                    'FromDate', w0,
                    'ToDate', w0,
                    'FinancialYearCode', w1
                ]);
            }
        }
    }
}
